/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponDiscountApiFrom } from '../../models/coupon-discount-api-from';

export interface ApiV3ServiceGetCouponDiscountGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * coupon number (printed)
 */
  cpnNo?: string;

/**
 * basket value
 */
  sum?: number;

/**
 * cart appearance (same as when creating)
 */
  basketExtId?: string;
}

export function apiV3ServiceGetCouponDiscountGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceGetCouponDiscountGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDiscountApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceGetCouponDiscountGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('cpnNo', params.cpnNo, {});
    rb.query('sum', params.sum, {});
    rb.query('basketExtId', params.basketExtId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponDiscountApiFrom>;
    })
  );
}

apiV3ServiceGetCouponDiscountGet$Plain.PATH = '/api/v3/service/GetCouponDiscount';
